import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Icon } from '@drifthq/tide-core'
import chroma from 'chroma-js'
import cx from 'classnames'

import SetupProgress from 'layouts/SetupProgress'
import PasswordStep from 'layouts/PasswordStep'
import ProfileColorStep from 'layouts/ProfileColorStep'
import ProfileDetailsStep from 'layouts/ProfileDetailsStep'
import ProfilePhotoStep from 'layouts/ProfilePhotoStep'
import MeetingsStepWithPrime from 'layouts/MeetingsStepWithPrime'
import ExtensionStep from 'layouts/ExtensionStep'
import TreeringTestimonial from 'layouts/TreeringTestimonial'
import LolaTestimonial from 'layouts/LolaTestimonial'
import SegmentTestimonial from 'layouts/SegmentTestimonial'
import ProfilePreview from 'layouts/ProfilePreview'
import MeetingPreview from 'layouts/MeetingPreview'
import ExtensionPreview from 'layouts/ExtensionPreview'
import CalendarSelectStep from 'layouts/CalendarSelectStep'
import InstallVerifyStep from 'layouts/InstallVerifyStep'
import ProfileDetails from 'layouts/ProfileDetails'
import ConvoSidebar from 'layouts/ConvoPreview'
import Welcome from 'layouts/Welcome'
import MessageWidget from 'layouts/CustomMessage'
import CustomizeDrift from 'layouts/CustomizeDrift'
import ChatWidget from 'layouts/ChatPreview'
import MobileConfirmationStep from 'layouts/MobileConfirmationStep'
import MoseleyTestimonial from 'layouts/MoseleyTestimonial'
import SchedulingCardPreview from 'layouts/SchedulingCardPreview'
import MeetingsBookedPreview from 'layouts/MeetingsBookedPreview'
import MeetingTypesPreview from 'layouts/MeetingTypesPreview'
import MeetingsDemoStep from 'layouts/MeetingsDemoStep'
import MeetingsInConvoPreview from 'layouts/MeetingsInConvoPreview'

import InstallChoice from 'layouts/InstallChoice'
import NotificationModal from 'components/NotificationModalExp'

import './style.css'

const Setup = ({ match: { url }, color, location: { pathname }, finishOnboardingNotification, properties }) => {
  const profileColor = `#${color}`
  const isTouchless = pathname.includes('touchless') || pathname.includes('start')
  const isCalendarSeat = pathname.startsWith('/setup/calendaring')

  return (
    <div className={cx('setup-container', { 'setup-container--touchless': isTouchless || isCalendarSeat })}>
      <div className="setup-container-fields-wrapper">
        <div className="setup-container-fields">
          <Icon className="setup-container-drift-logo" name="drift-logo-full"/>
          <SetupProgress/>
          <Switch>
            <Redirect exact from={url} to={`${url}/profile`}/>
            <Redirect exact from={`${url}/profile`} to={`${url}/profile/photo`}/>
            <Redirect exact from={`${url}/touchless/account`} to={`/start`} />
            <Route path={`${url}/profile/photo`} component={ProfilePhotoStep}/>
            <Route path={`${url}/profile/color`} component={ProfileColorStep}/>
            <Route path={`${url}/profile/details`} component={ProfileDetailsStep}/>
            <Route path={`${url}/password`} component={PasswordStep}/>
            <Route path={`${url}/meetings/calendar`} component={CalendarSelectStep}/>
            <Route path={`${url}/meetings`} component={MeetingsStepWithPrime}/>
            <Route path={`${url}/extension`} component={ExtensionStep}/>
            <Route path={`${url}/touchless/welcome`} component={Welcome}/>
            <Route path={`${url}/touchless/custom`} component={CustomizeDrift}/>
            <Route path={`${url}/touchless/details`} component={ProfileDetails}/>
            <Route path={`${url}/touchless/install/verify`} component={InstallVerifyStep}/>
            <Route path={`${url}/touchless/mobile`} component={MobileConfirmationStep}/>
            <Route path={`${url}/touchless/install`} component={InstallChoice}/>
            <Route path={`${url}/calendaring/activate`} render={() => <PasswordStep isCalendarSeat={true} />}/>
            <Route path={`${url}/calendaring/profile`} render={() => <ProfilePhotoStep isCalendarSeat={true} />}/>
            <Route path={`${url}/calendaring/connect`} render={() => <MeetingsStepWithPrime isCalendarSeat={true} />}/>
            <Route path={`${url}/calendaring/select`} render={() => <CalendarSelectStep isCalendarSeat={true} />}/>
            {/* <Route path={`${url}/calendaring/extension`} render={() => <ExtensionStep isCalendarSeat={true} />}/> */}
            <Route path={`${url}/calendaring/hooray`} component={MeetingsDemoStep} />
          </Switch>
          { isTouchless && properties.lastStep && <NotificationModal showModal={finishOnboardingNotification} text="Let’s finish up your account setup, this is where you left off last time" /> }
        </div>
      </div>
      <div
        style={{
          background: `linear-gradient(to bottom, ${profileColor}, ${chroma(profileColor).darken().hex()})`
        }}
        className="setup-container-preview"
      >
        <Switch>
          <Route path={`${url}/profile`} component={ProfilePreview}/>
          <Route path={`${url}/password`} render={() => <TreeringTestimonial meetings={true}/>}/>
          <Route path={`${url}/meetings`} component={MeetingPreview}/>
          <Route path={`${url}/extension`} component={ExtensionPreview}/>
          <Route path={`${url}/touchless/welcome`} component={MessageWidget}/>
          <Route path={`${url}/touchless/custom`} component={ChatWidget}/>
          <Route path={`${url}/touchless/details`} component={ConvoSidebar}/>
          <Route path={`${url}/touchless/account`} component={LolaTestimonial}/>
          <Route path={`${url}/touchless/install`} component={SegmentTestimonial}/>
          <Route path={`${url}/touchless/continue`} component={TreeringTestimonial}/>
          <Route path={`${url}/calendaring/activate`} component={MoseleyTestimonial}/>
          <Route path={`${url}/calendaring/profile`} component={SchedulingCardPreview}/>
          <Route path={`${url}/calendaring/connect`} component={() => <MeetingsBookedPreview isCalendarSeat={true} />}/>
          <Route path={`${url}/calendaring/select`} component={() => <MeetingTypesPreview isCalendarSeat={true} />}/>
          {/* <Route path={`${url}/calendaring/extension`} component={() => <ExtensionPreview isCalendarSeat={true} />}/> */}
          <Route path={`${url}/calendaring/hooray`} component={MeetingsInConvoPreview}/>
        </Switch>
      </div>
    </div>
  )
}

export default Setup



// WEBPACK FOOTER //
// ./src/layouts/Setup/component.js